import React from "react";

const CustomButton = ({
  label = "Click Me",
  onClick,
  icon = null,
  type = "button",
  size = "md",
  variant = "primary",
  rounded = false,
  fullWidth = false,
  gradient = false,
  disabled = false,
  backgroundColor = "rgb(200 194 247)",
  labelColor = "white",
  className = "",
  id,
  isLoading = false, // Default to false if not passed
}) => {
  const baseClasses =
    "inline-flex items-center justify-center font-bold transition-all duration-300 focus:outline-none";

  const sizeClasses = {
    sm: "text-sm px-3 py-1.5",
    md: "text-md px-5 py-2",
    lg: "text-lg px-7 py-3",
  };

  const roundedClass = rounded ? "rounded-full" : "rounded-sm";
  const fullWidthClass = fullWidth ? "w-full" : "w-auto";
  const gradientClass = gradient
    ? "bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 hover:from-blue-600 hover:to-pink-600"
    : "";

  const disabledClass = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";

  return (
    <button
      id={id}
      type={type}
      onClick={!disabled && !isLoading ? onClick : undefined} // Disable onClick when loading or disabled
      style={{
        backgroundColor: gradient ? undefined : backgroundColor,
        color: labelColor,
        textAlign: "center",
      }}
      className={`focus:outline-none focus:ring-2 focus:ring-black ${baseClasses} ${sizeClasses[size]} ${roundedClass} ${fullWidthClass} ${gradientClass} ${disabledClass} ${className}`}
      disabled={disabled || isLoading} // Disable button when loading or disabled
    >
      {/* If icon is present, add margin to the right */}
      {icon && <span className="mr-2">{icon}</span>}

      {/* Conditional rendering for the label or loading spinner */}
      {isLoading ? (
        <svg
          role="status"
          className="w-5 h-5 text-white animate-spin"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M99.79 50.13c0-27.52-22.38-49.9-49.9-49.9-27.52 0-49.9 22.38-49.9 49.9 0 27.52 22.38 49.9 49.9 49.9 27.52 0 49.9-22.38 49.9-49.9zM93.65 50.13c0 23.48-19.1 42.58-42.58 42.58-23.48 0-42.58-19.1-42.58-42.58 0-23.48 19.1-42.58 42.58-42.58 23.48 0 42.58 19.1 42.58 42.58z"
            fill="currentColor"
          />
        </svg>
      ) : (
        <span className="text-center">{label}</span> // Simple span for label text
      )}
    </button>
  );
};

export default CustomButton;
